import React, { useEffect, useRef, useMemo, useState } from "react";
import { TileLayer, Marker, Popup } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-cluster";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import IconV from "../../../assets/icons/vakansa-map-pin.png";
import IconVShadow from "../../../assets/icons/vakansa-map-pin-shadow.png";
import AdCard from "../AdCard/AdCard";
import "./mapSection.css";
import { MapContainerWithGestureHandling } from "../../../components/MapContainerGesture/MapContainerWithGestureHandling";
import { MAP_TILE_LAYER } from "../../../utils/mapTiles";
import MobileAdCard from "../MobileAdCard/MobileAdCard";

function MapSection({ ad }) {
  const mapRef = useRef(null);
  const [activeAdId, setActiveAdId] = useState(null);
  const isMobile = window.innerWidth < 800;

  const centerCoordinates = useMemo(
    () => [60.31582836539714, 15.318138912667642],
    [],
  );
  const mapZoom = 6;

  const customIcon = useMemo(() => {
    return L.icon({
      iconUrl: IconV,
      shadowUrl: IconVShadow,
      iconSize: [38, 37],
      iconAnchor: [28, 40],
      shadowSize: [38, 43],
      shadowAnchor: [17, 46],
    });
  }, []);

  const createClusterCustomIcon = useMemo(() => {
    return function (cluster) {
      return L.divIcon({
        html: `<span>${cluster.getChildCount()}</span>`,
        className: "custom-marker-cluster",
        iconSize: L.point(33, 33, true),
      });
    };
  }, []);

  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.setView(centerCoordinates, mapZoom);
    }
  }, [centerCoordinates]);

  return (
    <div className="map-section">
      <MapContainerWithGestureHandling
        className="map-container"
        center={centerCoordinates}
        zoom={mapZoom}
        scrollWheelZoom={true}
        ref={mapRef}
      >
        <TileLayer {...MAP_TILE_LAYER} />
        <MarkerClusterGroup
          iconCreateFunction={createClusterCustomIcon}
          maxClusterRadius={60}
          spiderfyOnMaxZoom={true}
          showCoverageOnHover={false}
        >
          {ad.map((ad, index) => (
            <Marker
              key={index}
              position={[
                ad.location.coordinates[1],
                ad.location.coordinates[0],
              ]}
              icon={customIcon}
              eventHandlers={{
                click: () => setActiveAdId(ad._id),
              }}
            >
              <Popup
                className="map-section-popup"
                onClose={() => setActiveAdId(null)}
              >
                {activeAdId === ad._id ? (
                  isMobile === false ? (
                    <AdCard
                      id={ad}
                      onClose={() => {
                        setActiveAdId(null);
                        mapRef.current?.closePopup();
                      }}
                    />
                  ) : isMobile === true ? (
                    <MobileAdCard
                      id={ad}
                      onClose={() => {
                        setActiveAdId(null);
                        mapRef.current?.closePopup();
                      }}
                    />
                  ) : null
                ) : null}
              </Popup>
            </Marker>
          ))}
        </MarkerClusterGroup>
      </MapContainerWithGestureHandling>
    </div>
  );
}

export default MapSection;
